import React from 'react';
import { WebLayout } from '../components/web-layout';

export class RegisterSuccess extends React.Component {

    render() {
        return (
            <WebLayout>
                <h2 className='text-center'>Thank You!</h2>
                <h4 className='text-center'>HabitNu will contact you via email to complete your registration. </h4>
            </WebLayout>
        )
    }

}